import {IWithBirthDate} from 'Common/models/IWithBirthDate';
import {convertToClientDate} from 'Common/helpers/DateHelper';

export function withBirthDate<T extends IWithBirthDate>(model: T) {
  return {
    ...model,
    dateOfBirth: model.dateOfBirth ? convertToClientDate(model.dateOfBirth) : null
  };
}
